import {
	AliasAuthenticationMessageOperationOutputDto,
	AliasAuthenticationTypeOperationOutputDto,
	ClickToCallAgentClosedOutputDto,
	ClickToCallAgentOpenOutputDto,
	ClickToCallAllInternationalDialingPhoneCodesOutputDto,
	ClickToCallIsOpenOutputDto,
	ClickToCallStatusOutputDto,
	ContextOutputDto,
	RetrieveDocumentsReferenceOutputDto,
	RetrieveAccountsOutputDto,
	SubscriptionOutputDto,
	RetrieveCompanyOutputDto,
} from '@api/ecommerce-xp';

export interface ServiceError {
	code: string;
	message: string;
}

export interface ServicesState {
	aliasAuthenticationMessage?: AliasAuthenticationMessageOperationOutputDto;
	aliasAuthenticationType?: AliasAuthenticationTypeOperationOutputDto;
	clickToCallAgentClosed?: ClickToCallAgentClosedOutputDto;
	clickToCallAgentOpen?: ClickToCallAgentOpenOutputDto;
	clickToCallAllInternationalDialingPhoneCodes?: ClickToCallAllInternationalDialingPhoneCodesOutputDto;
	clickToCallIsOpen?: ClickToCallIsOpenOutputDto;
	clickToCallStatus?: ClickToCallStatusOutputDto;
	error?: ServiceError;
	retrieveAccounts?: RetrieveAccountsOutputDto;
	retrieveContext?: ContextOutputDto;
	retrieveBankDocumentReference?: RetrieveDocumentsReferenceOutputDto;
	subscription?: SubscriptionOutputDto;
	retrieveCompany?: RetrieveCompanyOutputDto;
}

export const ServicesActionTypes = {
	saveSuccessServiceResponse: '@@Services/saveSuccessServiceResponse',
	saveErrorServiceResponse: '@@Services/saveErrorServiceResponse',
};
